<template lang="pug">
section
  div
    | Before making a decision
    | about your application
    | the Home Office may:

  ul
    li
      | conduct an on-site visit
      | at your office or,
      | if you operate on a virtual business model,
      | they will visit
      | your authorising officer’s physical address
      | to ensure you are able to comply
      | with your future sponsorship duties;
    li
      | perform other checks
      | (including with other government departments)
      | on your business;
    li
      | request additional documents
      | you must provide to them.

  br

  div
    | ❗
    |
    | If the Home Office require
    | any more information,
    | evidence or documents,
    | they will contact you by email.
    | You must send the documents
    | or information they ask
    | for within 5 working days.
    | If you fail to send within a given time,
    | your application will be refused
    | and your fee will not be refunded.

  br

  div
    | 🚀
    |
    span(style="background: #ccedeb")
      | If the Home Office notifies you
      | about the pre-licence visit,
      | let Nation.better know.
      | We will provide you
      | with a step-by-step guide
      | on how to successfully
      | pass a visit audit!
</template>

<script>
export default {
  name: "decision_visits_and_checks",
};
</script>